import {
  ORDER_FULFILLMENT_SOURCE_VALUES,
  type OrderFulfillmentSource,
  type OrderFulfillmentSourceDto,
} from '../types/order';
import { asRecord, reportDtoAnomaly } from './common';

export function normalizeOrderFulfillmentSourceDto(raw: unknown): OrderFulfillmentSourceDto {
  const record = asRecord(raw);
  const source = record?.source;

  if (
    typeof source === 'string'
    && ORDER_FULFILLMENT_SOURCE_VALUES.includes(source as OrderFulfillmentSource)
  ) {
    return { source: source as OrderFulfillmentSource };
  }

  reportDtoAnomaly('OrderFulfillmentSourceDto', 'source', source);
  return { source: 'UNASSIGNED' };
}
